import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Send, Paperclip, Smile } from 'lucide-react';

const ChatRoom = () => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  // Dummy messages for chat room
  const messages = [
    {
      id: 1,
      sender: 'Alex Chen',
      content: 'Hey! Want to grab coffee later?',
      time: '2:30 PM',
      isMine: false,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
      id: 2,
      sender: 'You',
      content: 'Sure! Where were you thinking?',
      time: '2:32 PM',
      isMine: true
    },
    {
      id: 3,
      sender: 'Alex Chen',
      content: 'How about that new place on Valencia? Blue Bottle Coffee?',
      time: '2:33 PM',
      isMine: false,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
      id: 4,
      sender: 'You',
      content: 'Perfect! See you at 4?',
      time: '2:35 PM',
      isMine: true
    }
  ];

  const handleSend = () => {
    if (message.trim()) {
      console.log('Sending message:', message);
      setMessage('');
    }
  };

  return (
    <div className="screen" style={{ paddingBottom: '0' }}>
      {/* Chat Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 20px',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        position: 'sticky',
        top: '0',
        zIndex: '100'
      }}>
        <button 
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px'
          }}
        >
          <ArrowLeft size={20} />
        </button>
        <img 
          src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" 
          alt="Alex Chen"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>
            Alex Chen
          </div>
          <div style={{ fontSize: '12px', color: '#667eea' }}>
            Active now
          </div>
        </div>
      </div>

      {/* Messages */}
      <div style={{
        flex: 1,
        padding: '20px',
        paddingBottom: '100px',
        minHeight: 'calc(100vh - 140px)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        {messages.map((msg) => (
          <div key={msg.id} style={{
            display: 'flex',
            flexDirection: msg.isMine ? 'row-reverse' : 'row',
            alignItems: 'flex-end',
            gap: '8px'
          }}>
            {!msg.isMine && (
              <img 
                src={msg.avatar} 
                alt={msg.sender}
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            )}
            <div style={{
              maxWidth: '70%',
              background: msg.isMine 
                ? 'linear-gradient(135deg, #667eea, #764ba2)'
                : 'rgba(255, 255, 255, 0.95)',
              color: msg.isMine ? 'white' : '#1a1a1a',
              padding: '12px 16px',
              borderRadius: msg.isMine ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
              backdropFilter: 'blur(20px)',
              border: msg.isMine ? 'none' : '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{ fontSize: '15px', lineHeight: '1.4' }}>
                {msg.content}
              </div>
              <div style={{
                fontSize: '11px',
                opacity: 0.7,
                marginTop: '4px',
                textAlign: msg.isMine ? 'right' : 'left'
              }}>
                {msg.time}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Message Input */}
      <div style={{
        position: 'fixed',
        bottom: '80px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '430px',
        padding: '16px 20px',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        zIndex: '100'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '24px',
          padding: '8px 12px',
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }}>
          <button style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            color: '#666'
          }}>
            <Paperclip size={18} />
          </button>
          <input
            type="text"
            placeholder="Type a message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            style={{
              flex: 1,
              border: 'none',
              outline: 'none',
              background: 'transparent',
              fontSize: '15px',
              padding: '8px 4px'
            }}
          />
          <button style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            color: '#666'
          }}>
            <Smile size={18} />
          </button>
          <button
            onClick={handleSend}
            disabled={!message.trim()}
            style={{
              background: message.trim() 
                ? 'linear-gradient(135deg, #667eea, #764ba2)'
                : 'rgba(0, 0, 0, 0.1)',
              color: message.trim() ? 'white' : '#999',
              border: 'none',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: message.trim() ? 'pointer' : 'not-allowed',
              transition: 'all 0.3s ease'
            }}
          >
            <Send size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatRoom;